import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminNavbar from "../Layout/AdminNavbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import API_BASE_URL, { COMPANY_NAME } from "../config";

const LeaveManagement = () => {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [leaveLogs, setLeaveLogs] = useState([]);
    const [creditedDate, setCreditedDate] = useState("");
    const [financialYear, setFinancialYear] = useState("");
    const [encashDate, setEncashDate] = useState("");
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [rejectLeaveId, setRejectLeaveId] = useState(null);
    const [statusFilter, setStatusFilter] = useState("ALL");
    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [showCreditModal, setShowCreditModal] = useState(false);
    const [modalLeaveType, setModalLeaveType] = useState("");
    const [modalLeavesPerMonth, setModalLeavesPerMonth] = useState("");
    const [availableLeaveTypes, setAvailableLeaveTypes] = useState([]);
    const [leaveSummary, setLeaveSummary] = useState([]);
    const [modalEmployeeId, setModalEmployeeId] = useState("");
    const [creditEmployees, setCreditEmployees] = useState([]);
    const [showAvailModal, setShowAvailModal] = useState(false);
    const [financialYearFrom, setFinancialYearFrom] = useState("");
    const [financialYearTo, setFinancialYearTo] = useState("");
    const [lopDays, setLopDays] = useState(0);


    const [availForm, setAvailForm] = useState({
        leaveType: "",
        startDate: "",
        endDate: "",
        reason: "",
        document: null,
    });

    const [showEncashModal, setShowEncashModal] = useState(false);

    const [encashForm, setEncashForm] = useState({
        leaveType: "",
        days: ""
    });

    const [sortConfig, setSortConfig] = useState({
        key: "",
        direction: "asc",
    });


    const sortedCreditEmployees = [...creditEmployees].sort((a, b) =>
        a.user.name.localeCompare(b.user.name)
    );


    // const fetchAppliedLeaves = () => {
    //     const token = localStorage.getItem("token");
    //     if (!token || !selectedEmployee) return;

    //     fetch(`${API_BASE_URL}/api/leaves/all`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             // filter by selected employee
    //             const emp = employees.find(e => e.id === Number(selectedEmployee));
    //             if (!emp) return;

    //             const filtered = data.filter(
    //                 l => l.employeeName === emp.user.name
    //             );

    //             setAppliedLeaves(filtered);
    //         })
    //         .catch(err => console.error("Error fetching applied leaves", err));
    // };



    const handleAvailSubmit = async () => {
        try {
            const token = localStorage.getItem("token");

            if (
                !modalEmployeeId ||
                !availForm.leaveType ||
                !availForm.startDate ||
                !availForm.endDate ||
                !availForm.reason
            ) {
                toast.error("Please fill all required fields");
                return;
            }

            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/avail`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: availForm.leaveType,
                        startDate: availForm.startDate,
                        endDate: availForm.endDate,
                        reason: availForm.reason,
                        financialYear: financialYear,
                    }),
                }
            );

            if (!res.ok) {
                const errorText = await res.text();

                //  show friendly message only
                if (errorText.includes("Insufficient leave balance")) {
                    toast.error("Insufficient leave balance");
                } else {
                    toast.error("Failed to avail leave");
                }
                return;
            }

            toast.success("Leave availed successfully");

            setShowAvailModal(false);
            setAvailForm({
                leaveType: "",
                startDate: "",
                endDate: "",
                reason: "",
                document: null,
            });

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong. Please try again.");
        }
    };


    const getStartOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        return `01/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };

    const getEndOfMonth = (value) => {
        if (!value) return "";

        const [month, year] = value.trim().split(" ");

        const monthIndex = new Date(`${month} 1, ${year}`).getMonth();
        if (isNaN(monthIndex)) return "";

        //  last day of the month
        const lastDay = new Date(year, monthIndex + 1, 0).getDate();

        return `${lastDay}/${String(monthIndex + 1).padStart(2, "0")}/${year}`;
    };

    const parseDDMMYYYY = (dateStr) => {
        if (!dateStr) return null;
        const [dd, mm, yyyy] = dateStr.split("/");
        return new Date(`${yyyy}-${mm}-${dd}`);
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        const roles = JSON.parse(localStorage.getItem("roles") || "[]");

        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
            return;
        }

        //  check admin role
        if (!roles.includes("ROLE_ADMIN")) {
            toast.error("You are not authorized to access this page.");
            navigate("/");
            return;
        }
    }, [navigate]);

    // useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     fetch(`${API_BASE_URL}/api/users`, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setEmployees(data.filter(u => u.status === "Active"));
    //         })
    //         .catch(err => console.error(err));
    // }, []);

    useEffect(() => {
        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/company-info`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {


                // API returns array → take first record
                const company = Array.isArray(data) ? data[0] : data;

                if (!company?.financialYear) {
                    console.warn("No financialYear found");
                    return;
                }

                setFinancialYear(company.financialYear);

                const parts = splitFinancialYear(company.financialYear);

                if (parts.length !== 2) {
                    console.warn("Invalid financialYear format:", company.financialYear);
                    return;
                }

                const [from, to] = parts;

                setFinancialYearFrom(getStartOfMonth(from));
                setFinancialYearTo(getEndOfMonth(to));
            })

            .catch(err => console.error("Error fetching company info:", err));
    }, []);

    const toInputDate = (ddmmyyyy) => {
        if (!ddmmyyyy) return "";
        const [dd, mm, yyyy] = ddmmyyyy.split("/");
        return `${yyyy}-${mm}-${dd}`;
    };

    const minCreditDate = toInputDate(financialYearFrom);
    const maxCreditDate = toInputDate(financialYearTo);

    const minAvailDate = toInputDate(financialYearFrom);
    const maxAvailDate = toInputDate(financialYearTo);

    const minEncashDate = toInputDate(financialYearFrom);
    const maxEncashDate = toInputDate(financialYearTo);

    useEffect(() => {
        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/employees/active`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {
                setEmployees(data);
                setCreditEmployees(data); //  independent list

                const uniqueDepartments = [
                    ...new Set(data.map(emp => emp.department).filter(Boolean))
                ];
                setDepartments(uniqueDepartments);

                setFilteredEmployees(data); // page filters only
            })
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (!selectedDepartment) {
            // nothing selected → show no employees
            setFilteredEmployees([]);
            setSelectedEmployee("");
            return;
        }

        if (selectedDepartment === "ALL") {
            setFilteredEmployees(employees);
        } else {
            setFilteredEmployees(
                employees.filter(emp => emp.department === selectedDepartment)
            );
        }

        // reset employee when department changes
        setSelectedEmployee("");
    }, [selectedDepartment, employees]);


    //frontend filter by financial year
    // const fetchLogs = () => {
    //     const token = localStorage.getItem("token");

    //     if (!selectedEmployee || !financialYearFrom || !financialYearTo) {
    //         setLeaveLogs([]);
    //         return;
    //     }

    //     const fyStart = parseDDMMYYYY(financialYearFrom);
    //     const fyEnd = parseDDMMYYYY(financialYearTo);

    //     fetch(`${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             const filtered = data.filter(log => {
    //                 if (!log.startDate) return false;

    //                 const logDate = new Date(log.startDate);
    //                 return logDate >= fyStart && logDate <= fyEnd;
    //             });

    //             setLeaveLogs(filtered);
    //         })
    //         .catch(err =>
    //             console.error("Error fetching leave transactions", err)
    //         );
    // };



    //frontend filter by financial year
    // useEffect(() => {
    //     fetchLogs();
    // }, [selectedEmployee]);


    //from fanacial filter by directly backend

    const fetchLogs = () => {
        const token = localStorage.getItem("token");

        if (!selectedEmployee || !financialYear) {
            setLeaveLogs([]);
            return;
        }

        fetch(
            `${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}/financial-year?financialYear=${financialYear}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then(res => res.json())
            .then(data => setLeaveLogs(data))
            .catch(err =>
                console.error("Error fetching leave transactions", err)
            );
    };


    //from fanacial filter by directly backend

    useEffect(() => {
        fetchLogs();
    }, [selectedEmployee, financialYear]);


    //Not Filter All
    // const fetchLogs = () => {
    //     const token = localStorage.getItem("token");

    //     if (!selectedEmployee) {
    //         setLeaveLogs([]);
    //         return;
    //     }

    //     fetch(`${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then(res => res.json())
    //         .then(data => setLeaveLogs(data))
    //         .catch(err => console.error("Error fetching leave transactions", err));
    // };  

    const handleCredit = async () => {
        if (
            !modalEmployeeId ||
            !modalLeaveType ||
            !modalLeavesPerMonth ||
            !creditedDate

        ) {
            toast.error("Please select employee and fill all fields");
            return;
        }

        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/credit`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: modalLeaveType,
                        days: Number(modalLeavesPerMonth),
                        startDate: creditedDate,
                        financialYear: financialYear, //  from company-info
                    }),
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave credited successfully");

            setShowCreditModal(false);
            setModalLeaveType("");
            setModalLeavesPerMonth("");
            setCreditedDate("");

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to credit leave");
        }
    };

    const handleEncashSubmit = async () => {
        const token = localStorage.getItem("token");

        if (
            !modalEmployeeId ||
            !encashForm.leaveType ||
            !encashForm.days ||
            !encashDate
        ) {
            toast.error("Please fill all required fields");
            return;
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/encash`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        employeeId: Number(modalEmployeeId),
                        leaveType: encashForm.leaveType,
                        days: Number(encashForm.days),
                        startDate: encashDate,
                        financialYear: financialYear,
                    }),
                }
            );

            if (!res.ok) {
                const errorText = await res.text();

                //  show clean message only
                if (errorText.includes("Insufficient leave balance")) {
                    toast.error("Insufficient leave balance");
                } else {
                    toast.error("Failed to encash leave");
                }
                return;
            }

            toast.success("Leave encashed successfully");

            setShowEncashModal(false);
            setEncashForm({ leaveType: "", days: "" });
            setEncashDate("");

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error("Something went wrong. Please try again.");
        }
    };

    const confirmDelete = (log, onConfirm) => {
        toast(
            ({ closeToast }) => (
                <div style={{ minWidth: "280px" }}>
                    <p className="fw-semibold mb-2 text-danger">
                        Confirm Delete
                    </p>

                    <div className="mb-2 small">
                        <div><strong>Employee:</strong> {log.employeeName}</div>
                        <div><strong>Leave Type:</strong> {log.leaveType}</div>
                        <div>
                            <strong>Date:</strong>{" "}
                            {log.startDate
                                ? new Date(log.startDate).toLocaleDateString()
                                : "-"}
                        </div>
                        <div><strong>Days:</strong> {log.days}</div>
                    </div>

                    <p className="mb-2 text-muted small">
                        Are you sure you want to delete this leave transaction?
                    </p>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={closeToast}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                closeToast();
                                onConfirm();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ),
            {
                autoClose: false,
                closeOnClick: false,
            }
        );
    };


    const handleDelete = (log) => {
        confirmDelete(log, async () => {
            const token = localStorage.getItem("token");

            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/leave-transactions/${log.id}`,
                    {
                        method: "DELETE",
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (!res.ok) {
                    toast.error("Failed to delete record");
                    return;
                }

                toast.success("Leave record deleted");

                fetchLogs();
                fetchLeaveSummary(selectedEmployee);

            } catch (err) {
                console.error(err);
                toast.error("Error deleting record");
            }
        });
    };


    useEffect(() => {
        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/leave-types/all`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => setAvailableLeaveTypes(data))
            .catch(err => console.error("Failed to fetch leave types:", err));
    }, []);


    useEffect(() => {
        fetchLeaveSummary(selectedEmployee);
    }, [selectedEmployee]);


    const filteredLogs = leaveLogs.filter(log => {
        const matchesSearch =
            log.leaveType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.leaveCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.leaveStatus?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.reason?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.processedBy?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.appliedBy?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus =
            statusFilter === "ALL" || log.leaveStatus === statusFilter;

        return matchesSearch && matchesStatus;
    });


    const fetchLeaveSummary = (userId) => {
        if (!userId || userId === "ALL") {
            setLeaveSummary([]);
            return;
        }

        const token = localStorage.getItem("token");

        fetch(
            `${API_BASE_URL}/api/leave-transactions/summary/${userId}?financialYear=${financialYear}`,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        )
            .then(res => res.json())
            .then(data => {
                const filtered = data.filter(item => Number(item.remaining) > 0);
                setLeaveSummary(filtered);
            })

            .catch((err) => console.error("Error fetching leave summary:", err));
    };


    const sortedLogs = [...filteredLogs].sort((a, b) => {
        if (!sortConfig.key) return 0;

        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        //  Handle null / undefined safely
        if (aVal == null) aVal = "";
        if (bVal == null) bVal = "";

        // date handling
        if (sortConfig.key === "startDate" || sortConfig.key === "endDate") {
            aVal = aVal ? new Date(aVal) : new Date(0);
            bVal = bVal ? new Date(bVal) : new Date(0);
        }

        // string handling
        if (typeof aVal === "string") {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });


    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const paginatedLogs = sortedLogs.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(filteredLogs.length / entriesPerPage);

    const handleSort = (key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                // toggle direction
                return {
                    key,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            }
            // new column sort
            return { key, direction: "asc" };
        });
    };


    const splitFinancialYear = (fy) => {
        return fy.split(/\s*[–-]\s*/); // works for –, —
    };


    // filter applied leaves by search
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);


    // const calculateDays = (start, end) => {
    //     if (!start || !end) return 0;
    //     const s = new Date(start);
    //     const e = new Date(end);
    //     return e >= s ? Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1 : 0;
    // };


    useEffect(() => {
        if (!availForm.leaveType) return;
        if (availForm.leaveType === "Loss of Pay(LOP)") return;

        if (!availForm.startDate || !availForm.endDate) return;

        const start = new Date(availForm.startDate);
        const end = new Date(availForm.endDate);
        const requestedDays =
            end >= start
                ? Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
                : 0;

        if (requestedDays === 0) return;

        const selectedLeave = leaveSummary.find(
            l => l.leaveType === availForm.leaveType
        );

        //  Not credited OR insufficient balance
        if (!selectedLeave || selectedLeave.remaining < requestedDays) {
            setAvailForm(prev => ({
                ...prev,
                leaveType: "Loss of Pay(LOP)"
            }));
        }

    }, [
        availForm.leaveType,
        availForm.startDate,
        availForm.endDate,
        leaveSummary
    ]);

    const handleApprove = async (logId) => {
        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/approve/${logId}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave approved");
            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to approve leave");
        }
    };

    const handleReject = async () => {
        if (!rejectReason.trim()) {
            toast.error("Please enter rejection reason");
            return;
        }

        const token = localStorage.getItem("token");

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/reject/${rejectLeaveId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        actionReason: rejectReason
                    }),
                }
            );

            if (!res.ok) {
                const msg = await res.text();
                throw new Error(msg);
            }

            toast.success("Leave rejected");
            setShowRejectModal(false);

            fetchLogs();
            fetchLeaveSummary(selectedEmployee);

        } catch (err) {
            console.error(err);
            toast.error(err.message || "Failed to reject leave");
        }
    };


    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "APPROVED":
                return "bg-success";
            case "REJECTED":
                return "bg-danger";
            case "PENDING":
                return "bg-warning text-dark";
            case "FORWARDED":
                return "bg-primary";
            case "CREDITED":
                return "bg-info text-dark";
            case "ENCASHED":
                return "bg-secondary";
            default:
                return "bg-light text-dark";
        }
    };


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token || !selectedEmployee || !financialYear) {
            setLopDays(0);
            return;
        }

        fetch(
            `${API_BASE_URL}/api/leave-transactions/employee/${selectedEmployee}/lop-days?financialYear=${financialYear}`,
            {
                headers: { Authorization: "Bearer " + token },
            }
        )
            .then(res => {
                if (!res.ok) throw new Error("Failed to fetch LOP days");
                return res.json();
            })
            .then(data => {
                setLopDays(data || 0);
            })
            .catch(err => {
                console.error("Error fetching LOP days:", err);
                setLopDays(0);
            });
    }, [selectedEmployee, financialYear]);


    const truncate = (text, max = 30) =>
        text && text.length > max ? text.substring(0, max) + "..." : text;


    const handleExport = async (format) => {

        const token = localStorage.getItem("token");

        // ✅ Ask confirmation if exporting all employees
        if (!selectedEmployee) {

            const confirmExport = window.confirm(
                "Export leave report for ALL employees?"
            );

            if (!confirmExport) return;
        }

        try {

            let url =
                `${API_BASE_URL}/api/reports/leave-transactions` +
                `?format=${format}` +
                `&financialYear=${financialYear}`;

            if (selectedEmployee) {
                url += `&employeeId=${selectedEmployee}`;
            }

            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!response.ok) throw new Error("Export failed");

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;

            let fileName = "Leave_Report_All_Employees";

            if (selectedEmployee) {
                const emp = employees.find(
                    e => String(e.id) === String(selectedEmployee)
                );

                const empName =
                    emp?.user?.name?.replace(/\s+/g, "_") || "Employee";

                fileName = `Leave_Report_${empName}`;
            }

            link.download =
                `${fileName}_${financialYear}.${format === "pdf" ? "pdf" : "xlsx"}`;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            toast.success("Report downloaded");

        } catch (error) {
            console.error(error);
            toast.error("Export failed");
        }
    };


    return (
        <>
            <div className="fixed-top">
                <AdminNavbar />
            </div>

            <div
                className="container-fluid bg-light"
                style={{ paddingTop: "130px", minHeight: "100vh" }}
            >
                <div className="d-flex justify-content-between align-items-center mb-3">

                    <h4 className="fw-bold mb-0">Leave Management</h4>

                    <div className="dropdown">
                        <button
                            className="btn btn-success btn-sm dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                        >
                            ⬇ Export
                        </button>

                        <ul className="dropdown-menu dropdown-menu-end">

                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => handleExport("excel")}
                                >
                                    📊 Export Excel
                                </button>
                            </li>

                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => handleExport("pdf")}
                                >
                                    📄 Export PDF
                                </button>
                            </li>

                        </ul>
                    </div>

                </div>

                {/* FILTER SECTION  */}
                <div className="card shadow-sm mb-3">
                    <div className="card-body">
                        <div className="row g-3 align-items-end">

                            {/* Department */}
                            <div className="col-md-2">
                                <label className="form-label">Select Department</label>
                                <select
                                    className="form-select"
                                    value={selectedDepartment}
                                    onChange={e => setSelectedDepartment(e.target.value)}
                                >
                                    <option value="" disabled>Select Department</option>
                                    <option value="ALL">ALL</option>
                                    {departments.map(dep => (
                                        <option key={dep} value={dep}>{dep}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Employee */}
                            <div className="col-md-2">
                                <label className="form-label">Select Employee</label>
                                <select
                                    className="form-select"
                                    value={selectedEmployee}
                                    onChange={e => setSelectedEmployee(e.target.value)}
                                    disabled={!selectedDepartment}
                                >
                                    <option value="" disabled>
                                        {selectedDepartment ? "Select Employee" : "Select Department First"}
                                    </option>
                                    {filteredEmployees.map(emp => (
                                        <option key={emp.id} value={String(emp.id)}>
                                            {emp.user.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* FY From */}
                            <div className="col-md-2">
                                <label className="form-label">Financial Year From</label>
                                <input className="form-control" value={financialYearFrom} disabled />
                            </div>

                            {/* FY To */}
                            <div className="col-md-2">
                                <label className="form-label">To Year</label>
                                <input className="form-control" value={financialYearTo} disabled />
                            </div>

                            {/* ACTION BUTTONS */}
                            <div className="col-md-4 d-flex gap-2 justify-content-end">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        setModalEmployeeId(selectedEmployee || "");
                                        setCreditedDate(new Date().toISOString().split("T")[0]);
                                        setShowCreditModal(true);
                                    }}
                                >
                                    ➕ Credit
                                </button>

                                <button
                                    className="btn btn-info text-white"
                                    onClick={() => {
                                        setModalEmployeeId(selectedEmployee || "");
                                        setShowAvailModal(true);
                                    }}
                                >
                                    ➖ Avail
                                </button>

                                <button
                                    className="btn btn-success"
                                    onClick={() => {
                                        setModalEmployeeId(selectedEmployee || "");
                                        setEncashForm({ leaveType: "", days: "" });
                                        setShowEncashModal(true);
                                    }}
                                >
                                    💰 Encash
                                </button>

                                <button
                                    className="btn btn-danger"
                                    onClick={() => navigate(-1)}
                                >
                                    ⏻ Exit
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {/*  SEARCH & ENTRIES */}
                <div className="d-flex align-items-center justify-content-start gap-4 mb-2 px-1">

                    {/* STATUS FILTER */}
                    <div className="d-flex align-items-center gap-2">
                        <label className="mb-0 fw-semibold">Status</label>
                        <select
                            className="form-select form-select-sm"
                            style={{ width: "130px" }}
                            value={statusFilter}
                            onChange={e => {
                                setStatusFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                        >
                            <option value="ALL">All</option>
                            <option value="PENDING">Pending</option>
                            <option value="FORWARDED">Forwarded</option>
                            <option value="APPROVED">Approved</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="CREDITED">Credited</option>
                            <option value="ENCASHED">Encashed</option>
                        </select>
                    </div>

                    {/* ENTRIES */}
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={entriesPerPage}
                            onChange={e => {
                                setEntriesPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={7}>7</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>
                    </div>

                    {/* SEARCH */}
                    <div className="d-flex align-items-center gap-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            style={{ width: "220px" }}
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={e => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                    </div>

                </div>

                {/* TABLES  */}
                <div className="row">
                    {/* LEFT TABLE */}
                    <div className="col-md-9">
                        <div className="card shadow-sm-none">
                            <div className="card-body p-0">
                                <table className="table table-bordered-none mb-0">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th onClick={() => handleSort("leaveCode")} style={{ cursor: "pointer" }}>
                                                Leave Code {sortConfig.key === "leaveCode" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th onClick={() => handleSort("leaveType")} style={{ cursor: "pointer" }}>
                                                Leave Type {sortConfig.key === "leaveType" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th onClick={() => handleSort("startDate")} style={{ cursor: "pointer" }}>
                                                Start Date {sortConfig.key === "startDate" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th onClick={() => handleSort("endDate")} style={{ cursor: "pointer" }}>
                                                End Date {sortConfig.key === "endDate" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th onClick={() => handleSort("days")} style={{ cursor: "pointer" }}>
                                                Days {sortConfig.key === "days" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th onClick={() => handleSort("leaveStatus")} style={{ cursor: "pointer" }}>
                                                Leave Status {sortConfig.key === "leaveStatus" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th>Leave Reason</th>

                                            <th onClick={() => handleSort("appliedBy")} style={{ cursor: "pointer" }}>
                                                Applied By {sortConfig.key === "appliedBy" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th>Reason</th>

                                            <th>Action</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedLogs.length > 0 ? (
                                            paginatedLogs.map(log => (
                                                <tr key={log.id}>
                                                    <td>{log.leaveCode}</td>
                                                    <td>{log.leaveType}</td>
                                                    <td>{log.startDate || "-"}</td>
                                                    <td>{log.endDate || "-"}</td>
                                                    <td>{log.days}</td>
                                                    <td>
                                                        <span className={`badge ${getStatusBadgeClass(log.leaveStatus)}`}>
                                                            {log.leaveStatus}
                                                        </span>

                                                    </td>
                                                    <td title={log.reason || ""}>
                                                        {truncate(log.reason, 30) || "—"}
                                                    </td>

                                                    <td>{log.processedBy || log.appliedBy || "-"}</td>
                                                    <td title={log.actionReason || ""}>
                                                        {truncate(log.actionReason, 30) || "—"}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex gap-2 flex-wrap align-items-center">

                                                            {(log.leaveStatus === "PENDING" || log.leaveStatus === "FORWARDED") && (
                                                                <>
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => handleApprove(log.id)}
                                                                    >
                                                                        Approve
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-sm btn-warning text-dark"
                                                                        onClick={() => {
                                                                            setRejectLeaveId(log.id);
                                                                            setRejectReason("");
                                                                            setShowRejectModal(true);
                                                                        }}
                                                                    >
                                                                        Reject
                                                                    </button>

                                                                </>
                                                            )}

                                                            {/* Delete always visible */}
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(log)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center text-muted py-4">
                                                    No leave records found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    {/* RIGHT BALANCE TABLE */}
                    <div className="col-md-3">
                        <div className="card shadow-sm-none">
                            <div className="card-body p-0">
                                <table className="table table-bordered-none mb-0">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th>Leave Type</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {leaveSummary.length > 0 ? (
                                            <>
                                                {leaveSummary.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.leaveType}</td>
                                                        <td>{item.remaining}</td>
                                                    </tr>
                                                ))}

                                                <tr>
                                                    <td><strong className="fw-semibold">Loss of Pay (LOP)</strong></td>
                                                    <td><strong className="text-danger">{lopDays}</strong></td>
                                                </tr>

                                                <tr className="table-secondary">
                                                    <td><strong>Total</strong></td>
                                                    <td>
                                                        <strong>
                                                            {leaveSummary.reduce((sum, item) => sum + Number(item.remaining), 0)}
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </>
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan="2" className="text-center text-muted py-3">
                                                        No remaining leave balance
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td><strong>Loss of Pay (LOP)</strong></td>
                                                    <td><strong className="text-danger">{lopDays}</strong></td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>

                </div>

                {/* PAGINATION */}
                {totalPages > 1 && (
                    <nav className="d-flex justify-content-center mt-3">
                        <ul className="pagination pagination-sm">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    Previous
                                </button>
                            </li>

                            {Array.from({ length: totalPages }, (_, i) => (
                                <li
                                    key={i}
                                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                </li>
                            ))}

                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                )}

                {/* FOOTER */}
                <hr className="my-4" />

                <div className="  text-center text-muted small">
                    © {new Date().getFullYear()} - {COMPANY_NAME}  · Balsuite System
                </div>



                {/* ACTION SECTION */}
                {/* <div className="card shadow-sm">
                    <div className="card-body">
                        <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">

                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setShowCreditModal(true);
                                }}
                            >
                                ➕ Credit
                            </button>



                            <button
                                className="btn btn-info text-white"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setShowAvailModal(true);
                                }}
                            >
                                ➖ Avail
                            </button>



                            <button
                                className="btn btn-success"
                                onClick={() => {
                                    setModalEmployeeId(selectedEmployee || "");
                                    setEncashForm({ leaveType: "", days: "" });
                                    setShowEncashModal(true);
                                }}
                            >
                                💰 Encash
                            </button>


                            <button className="btn btn-danger" onClick={() => navigate(-1)}>
                                ⏻ Exit
                            </button>

                        </div>
                    </div>
                </div> */}

                {/*CREDIT MODAL*/}
                {showCreditModal && (
                    <>
                        {/* Backdrop */}
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-md modal-dialog-centered" style={{ maxWidth: "35%" }}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Credit Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowCreditModal(false)}
                                        ></button>
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Select Employee</label>

                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={(e) => setModalEmployeeId(e.target.value)}
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "auto"
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        Select Employee
                                                    </option>

                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type / Code</label>
                                                <select
                                                    className="form-select"
                                                    value={modalLeaveType}
                                                    onChange={e => setModalLeaveType(e.target.value)}
                                                >
                                                    <option value="">Select Leave Type</option>

                                                    {availableLeaveTypes.length > 0 ? (
                                                        availableLeaveTypes.map(type => (
                                                            <option key={type.id} value={type.name}>
                                                                {type.name}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option disabled>Loading...</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leaves Per Month</label>
                                                <input
                                                    type="number"
                                                    step="0.5"
                                                    className="form-control"
                                                    value={modalLeavesPerMonth}
                                                    onChange={e => setModalLeavesPerMonth(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Credited Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={creditedDate}
                                                    min={minCreditDate}
                                                    max={maxCreditDate}
                                                    onChange={e => setCreditedDate(e.target.value)}
                                                />

                                            </div>

                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleCredit}
                                        >
                                            Save
                                        </button>

                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setShowCreditModal(false)}
                                        >
                                            Cancel
                                        </button>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showAvailModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-md modal-dialog-centered" style={{ maxWidth: "55%" }}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Avail Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowAvailModal(false)}
                                        />
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">
                                            {/* Employee */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Employee</label>
                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={e => setModalEmployeeId(e.target.value)}
                                                >
                                                    <option value="">Select Employee</option>
                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Leave Type */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type</label>
                                                <select
                                                    className="form-select"
                                                    value={availForm.leaveType}
                                                    onChange={e =>
                                                        setAvailForm({ ...availForm, leaveType: e.target.value })
                                                    }
                                                >
                                                    <option value="">Select Leave Type</option>

                                                    {availableLeaveTypes.map(type => (
                                                        <option key={type.id} value={type.name}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>

                                        {/* Dates */}
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.startDate}
                                                    min={minAvailDate}
                                                    max={maxAvailDate}
                                                    onChange={e =>
                                                        setAvailForm({
                                                            ...availForm,
                                                            startDate: e.target.value,
                                                            endDate: "" // reset end date if start changes
                                                        })
                                                    }
                                                />

                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">End Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={availForm.endDate}
                                                    min={availForm.startDate || minAvailDate}
                                                    max={maxAvailDate}
                                                    onChange={e =>
                                                        setAvailForm({ ...availForm, endDate: e.target.value })
                                                    }
                                                />

                                            </div>
                                        </div>

                                        {/* Reason */}
                                        <div className="mb-3">
                                            <label className="form-label">Reason</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={availForm.reason}
                                                onChange={e =>
                                                    setAvailForm({ ...availForm, reason: e.target.value })
                                                }
                                            />
                                        </div>

                                        {/* Document */}
                                        {/* <div className="mb-3">
                                            <label className="form-label">Supporting Document (optional)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={e =>
                                                    setAvailForm({ ...availForm, document: e.target.files[0] })
                                                }
                                            />
                                        </div> */}
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-info text-white"
                                            onClick={handleAvailSubmit}
                                        >
                                            Save
                                        </button>

                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowAvailModal(false)}
                                        >
                                            Cancel
                                        </button>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showEncashModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div
                                className="modal-dialog modal-md modal-dialog-centered"
                                style={{ maxWidth: "45%" }}
                            >
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Encash Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowEncashModal(false)}
                                        />
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <div className="row">

                                            {/* Employee */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Employee</label>
                                                <select
                                                    className="form-select"
                                                    value={modalEmployeeId}
                                                    disabled={!!selectedEmployee}
                                                    onChange={e => setModalEmployeeId(e.target.value)}
                                                >
                                                    <option value="">Select Employee</option>
                                                    {sortedCreditEmployees.map(emp => (
                                                        <option key={emp.id} value={emp.id}>
                                                            {emp.user.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Leave Type */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Leave Type</label>
                                                <select
                                                    className="form-select"
                                                    value={encashForm.leaveType}
                                                    onChange={e =>
                                                        setEncashForm({
                                                            ...encashForm,
                                                            leaveType: e.target.value
                                                        })
                                                    }
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    {availableLeaveTypes.map(type => (
                                                        <option key={type.id} value={type.name}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>

                                        <div className="row">

                                            {/* Encash Days */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Encash Days</label>
                                                <input
                                                    type="number"
                                                    min="0.5"
                                                    step="0.5"
                                                    className="form-control"
                                                    value={encashForm.days}
                                                    onChange={e =>
                                                        setEncashForm({
                                                            ...encashForm,
                                                            days: e.target.value
                                                        })
                                                    }
                                                    placeholder="Enter number of days"
                                                />
                                            </div>

                                            {/* Encash Date */}
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Encash Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={encashDate}
                                                    min={minEncashDate}
                                                    max={maxEncashDate}
                                                    onChange={e => setEncashDate(e.target.value)}
                                                />

                                            </div>

                                        </div>

                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button className="btn btn-success" onClick={handleEncashSubmit}>
                                            Save
                                        </button>

                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowEncashModal(false)}
                                        >
                                            Cancel
                                        </button>



                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showRejectModal && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show d-block" tabIndex="-1">
                            <div className="modal-dialog modal-sm modal-dialog-centered" style={{ maxWidth: "45%" }}>
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Reject Leave</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowRejectModal(false)}
                                        />
                                    </div>

                                    {/* Body */}
                                    <div className="modal-body">
                                        <label className="form-label">Rejection Reason</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={rejectReason}
                                            onChange={e => setRejectReason(e.target.value)}
                                            placeholder="Enter reason for rejection"
                                        />
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowRejectModal(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-warning"
                                            onClick={handleReject}
                                        >
                                            Reject
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </>
                )}


            </div>
        </>
    );
};

export default LeaveManagement;
